import { render } from "./NotFound.vue?vue&type=template&id=1e5fec56&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=1e5fec56&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1e5fec56"

export default script